import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { UploadFileStep } from './steps/UploadFileStep';
import { MatchProviderStep } from './steps/MatchProviderStep';

export class Import extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            dependencies: {
                steps: {
                    uploadFile: {
                        type: UploadFileStep,
                        callbacks: {
                            onChangeStep: (step, args) => this.onChangeStep(step, args),
                            onUpdateStep: (args, optionalStep, forceUpdate = true) => this.onUpdateStep(args, optionalStep, forceUpdate)
                        }
                    },
                    matchProviders: {
                        type: MatchProviderStep,
                        callbacks: {
                            onChangeStep: (step, args) => this.onChangeStep(step, args),
                            onUpdateStep: (args, optionalStep) => this.onUpdateStep(args, optionalStep)
                        }
                    },
                }
            },
            render: {
                isComponentLoaded: false,
                isTransportAuthority: false,
                step: {
                    component: null,
                    key: "uploadFile",
                    args: {}
                }
            },
            actions: {
                isLoadingEdition: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        const { selectedProvider } = this.context;
        const { dependencies, render } = this.state;

        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        if (selectedProvider !== undefined) {
            const selectedProviderId = selectedProvider.split(':')[0];
            render.isTransportAuthority = 0 === selectedProviderId || "0" === selectedProviderId;
        }

        render.isComponentLoaded = true;
        render.step.component = dependencies.steps[render.step.key];

        this.setState({
            render: render
        });
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    // -----------------------

    onChangeStep(step, args) {
        const { render, dependencies } = this.state;

        render.step.component = dependencies.steps[step];
        render.step.key = step;
        render.step.args = args;

        this.setState({
            render: render
        });
    }

    onUpdateStep(args, step = undefined, forceUpdate = false) {
        const { edition } = this.context;

        this.setState({
            message: {
                show: args.show,
                message: "",
                style: args.style,
                title: args.title,
                icon: args.icon,
                noButtons: args.noButtons
            }
        }, () => {
            const { message } = this.state;

            message.message = args.message;

            this.setState({
                message: message
            });
        });

        if (undefined !== step) {
            this.onChangeStep(step, {});
        }
        if (forceUpdate) {
            edition.update(edition.date, undefined, true);
        }
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ---------------------------

    renderStep() {
        const { render } = this.state;

        if (!render.isComponentLoaded) {
            return null;
        }

        if (null === render.step.component || undefined === render.step.component) {
            return null;
        }

        const step = React.createElement(
            render.step.component.type,
            Object.assign(
                { isTransportAuthority: render.isTransportAuthority },
                render.step.component.callbacks,
                render.step.args
            )
        );

        return (
            <React.Fragment>
                {step}
            </React.Fragment>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                {this.renderStep()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    noButtons={message.noButtons}
                    sticky
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title="A Carregar a Edição..."
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isLoadingEdition && !message.show}
                    small
                    noButtons />
            </div>
        );
    }
}
